<template>
  <div style="padding:20px;">
    <h1>Top Sales</h1>
    <DatePeriodSelector v-model="timestamps" lsComponentName='LocationTopSales' />
    
    <p>Report from {{formatDate(timestamps.from)}} to {{formatDate(timestamps.to)}}</p>
    
    <div>
      <!-- <table><tr> -->
        <div style="width:300px;float:left">Top :<input v-model="ls.top"></div>
        
        <CategorySelect v-model="ls.subtypes" style="width:300px;float:left">Include Categories:</CategorySelect>
        <CategorySelect v-model="ls.notSubtypes" style="width:300px;float:left">Exclude Categories:</CategorySelect>
        <div style="clear: left;"></div>
        <br>
        <!-- <p>🌟New: Simple include and exclude filters. E.g. Include:Pall Mall, Exclude:Special</p> -->
        Include Filter:<input v-model="ls.includeFilter">
        Exclude Filter:<input v-model="ls.excludeFilter">
        🌟Filter By Department:<input type="checkbox" v-model="ls.willFilterDepartment">
      <!-- </tr></table> -->
      
    </div>


    <div>
      <TopSalesTable v-model="topSalesData" :timestamps="timestamps" :qualifier="ls"/>
    </div>
  </div>

</template>

<script>
import DatePeriodSelector from '@/components/DatePeriodSelector.vue'
import TopSalesTable from './components/TopSalesTable.vue'
import CategorySelect from './components/CategorySelect.vue'
import localstorageMixin from '@/mixins/localstorageMixin.js'

export default {
  name: 'LocationTopSales',
  mixins : [localstorageMixin],
  components: {DatePeriodSelector, TopSalesTable, CategorySelect},
  data () { return {
    ls: {
      top : 20,
      subtypes : ['CIGS'],
      notSubtypes : [],
      includeFilter:"Pall Mall",
      excludeFilter:"Special",
      willFilterDepartment: false,
    },
    topSalesData: {}, 
    timestamps: {
      from: undefined,
      to: undefined,
    },
    previousTimestamps: {
      from: undefined,
      to: undefined,
    },
    } 
  },
  watch: {
    
  },
  methods: {
    lastYear: function(date){
      return moment(date).subtract(1, 'year').add(1,'day');
    },
    formatDate: function(date, formatStyle="ddd YYYY-MM-DD h:mm a"){
      return moment(date).format(formatStyle);
    },
  },
  computed: {
    lastYearTimestamps: function(){
      const result = {...this.timestamps}
      result.from = this.lastYear(result.from)
      result.to = this.lastYear(result.to)
      return result
    }
  }
}
</script>

<style>
.selected{
  /* opacity: 0.6; */
  background-color: darkgray;
}

tr:hover {
  background-color: inherit !important;
}
tr:active, .table-striped tr:active:nth-child(even) {
color: inherit !important;
background-color: inherit !important;
}
</style>
